export const colors = {
  primary: "#FF6B00",
  primaryLight: "#FF7A00",
  secondary: "#2d5199",
  secondaryLight: "#5FA7F5",
  tertiary: "#D35179",
  background: "#FFFFFF",
  lightGrey: "#C6C6C6",
  darkGrey: "#868686",
  text: "rgba(0, 0, 0, 0.85)",
  textInverted: "#FFFFFF",
  correct: "#3AB030",
  incorrect: "#838383",
  incorrectLearnMore: "#EC497B",
  difficulty: {
    beginner: "#78CCFB",
    intermediate: "#FFCD4E",
    advanced: "#FF4C41",
  },
};
